// eslint-disable-next-line import/prefer-default-export
export const data = {
    /// ////////////////////////////////////////////////////////////
    /// /////////////// Interrupt //////////////////////////////////
    /// ////////////////////////////////////////////////////////////
    Interrupt_header: <h4>EngagED Parent Portal Login Process (Internal/External)</h4>,
    Interrupt_p0: (
        <h5>
            To log in, you will{" "}
            <strong>
                <u>NOT</u>
            </strong>{" "}
            use your personal email.
        </h5>
    ),
    Interrupt_p1: (
        <>
            To log in, you will enter an email address comprised of your{" "}
            <strong>
                <u>username</u>
            </strong>{" "}
            followed by{" "}
            <strong>
                <u>@p.dcsdk12.org</u>
            </strong>{" "}
            on the login screen that follows.
            <br />
            For example: if <b>jsmith</b> is your username, you will enter{" "}
            <strong>
                <u>jsmith@p.dcsdk12.org</u>
            </strong>
            .
            <br />
            <br />
            Your password is the same as you use for accessing Infinite Campus (current parent) or the password you
            created during account setup for Open Enrollment (external parent).
        </>
    ),
    Interrupt_p2: (
        <strong>
            If you need assistance with your username or password, please go to{" "}
            <a href="https://password.dcsdk12.org" rel="noreferrer" target="_blank">
                password.dcsdk12.org
            </a>
            {"."}
        </strong>
    ),
    Interrupt_p3: (
        <>
            <b>If you are unable to access after following the above steps, please contact us:</b>
            <br />
            <a
                href="https://www.k12insight.com/Lets-Talk/embed.aspx?L=PRXB26D5K3LT"
                rel="noreferrer"
                style={{ color: "blue" }}
                target="_blank"
            >
                Parent Tech Support - English
            </a>
            <br />
            <a
                href="https://www.k12insight.com/Lets-Talk/embed.aspx?L=PRXB26D5K3LT@LFLT"
                rel="noreferrer"
                style={{ color: "blue" }}
                target="_blank"
            >
                Parent Tech Support - Spanish
            </a>
            <br />
            <a
                href="https://www.k12insight.com/Lets-Talk/embed.aspx?L=PRXB26D5K3LT@LRLT"
                rel="noreferrer"
                style={{ color: "blue" }}
                target="_blank"
            >
                Parent Tech Support - Chinese
            </a>
            <br />
            IT Support Center at <b>303.387.0001</b>
        </>
    ),
    Interrupt_note:
        "NOTE: District employees who are current parents should follow the instructions above using an incognito or private browser window and/or different browser.",
    Interrupt_submit: "Proceed to Login",
    /// /////////////////////////////////////////////////////////
    /// /////////////// Header //////////////////////////////////
    /// /////////////////////////////////////////////////////////
    Main_Nav_Welcome: "Welcome,",
    Main_Nav_HelpfulLinks: "Helpful Links",
    Main_Nav_LogOut: "LOGOUT",
    Main_Nav_HelpfulLinks_LI_s1: "Contact My Student(s) Nurse",
    Main_Nav_HelpfulLinks_LI_s2: "Academic Calendars",
    Main_Nav_HelpfulLinks_LI_s3: "Parent Resources",
    Main_Nav_HelpfulLinks_LI_s4: "Bus Routes",
    Main_Nav_HelpfulLinks_LI_s5: "Online Payments",
    Main_Nav_HelpfulLinks_LI_s6: "Lunch Menus",
    Main_Nav_Exit: "EXIT",
    /// /////////////////////////////////////////////////////////
    /// /////////////// Global //////////////////////////////////
    /// /////////////////////////////////////////////////////////
    Global_BackToDashboard: "Back to Dashboard",
    Global_Dashboard: "Dashboard",
    Global_Faq: "FAQ",
    Global_Close: "Close",
    Global_Completed: "Completed",
    Global_Currently_Unavailable: "Currently Unavailable",
    Global_InProgress: "In Progress",
    Global_GoTo: "Go To",
    Global_Loading: "Please wait while we gather your student's information ...",
    Global_MoreInfo: "More Info",
    Global_NotStarted: "Not Started",
    Global_Open: "Open",
    Global_Status: "Status",
    /// /////////////////////////////////////////////////////////
    /// /////////////// Breadcrumb //////////////////////////////
    /// /////////////////////////////////////////////////////////
    Breadcrumb: "DCSD Guardian Dashboard",
    Breadcrumb_Back: "DCSD Engaged Parent Portal",
    Breadcrumb_EPR: "DCSD Archived Report Cards",
    Breadcrumb_Translations: "Translations are experimental",
    /// /////////////////////////////////////////////////////////
    /// /////////////////// EPR /////////////////////////////////
    /// /////////////////////////////////////////////////////////
    EPR_Available: "Your student's Report Card will be available", // [some variable date string]
    EPR_Failure1: "Sorry, we are unable to retrieve the Report Card PDF for the student",
    EPR_Failure2: "Please provide the following information when contacting the district for support:",
    EPR_No_Data: "No historical Report Cards found for the student.",
    EPR_Not_Found:
        "Your student's Report Card isn't ready yet. Please contact your student's school for more information.",
    EPR_Success: "Report Card PDF retrieved successfully for the student.",
    EPR_Title: "Archived Report Card Resources",
    EPR_View_Archive: "Archived Report Cards",
    /// /////////////////////////////////////////////////////////
    /// /////////////////// Most Recent /////////////////////////
    /// /////////////////////////////////////////////////////////
    Most_Recent_Title: "Most Recent Report Card",
    Most_Recent_Pdf_Download: "Download PDF",
    Most_Recent_Success: "Report Card PDF retrieved successfully for the student.",
    /// /////////////////////////////////////////////////////////
    /// /////////////////// Student Info ////////////////////////
    /// /////////////////////////////////////////////////////////
    Student_Info_Address: "Address",
    Student_Info_Grade: "Grade",
    Student_Info_School: "School",
    Student_Info_School_Year: "School Year",
    Student_Info_Teacher: "Teacher",
    Student_Info_Not_Ready: (
        <>
            Report Card PDF is not ready.
            <br />
            Please check back soon.
        </>
    ),
    /// /////////////////////////////////////////////////////////
    /// /////////////////// Student Select //////////////////////
    /// /////////////////////////////////////////////////////////
    Student_Select_Instructions: "Select a student to view their Report Card",
    /// /////////////////////////////////////////////////////////
    /// /////////////////// About ///////////////////////////////
    /// /////////////////////////////////////////////////////////
    About_Epr: "About the Report Card",
    About_Based:
        "The Report Card is based on the Douglas County School District's Guaranteed and Viable Curriculum (GVC). All items are rated on the following scale:",
    About_Exceeds: "I exceed the expectations of the standards and can do them independently and accurately.",
    About_Meets: "I meet the expectations of the standards and can do them independently with no major errors.",
    About_Approaching: "I demonstrate partial understanding of the standards and/or need support to do them.",
    About_Does_Not_Meet: "I do not meet the expectations of the standards and/or need considerable support.",
    /// /////////////////////////////////////////////////////////
    /// /////////////////// Semester ////////////////////////////
    /// /////////////////////////////////////////////////////////
    Semester_Semester: "Semester",
    Semester_Selected: "Selected Semester",
    Semester_Overall: "Overall Comments",
    Semester_Comment_All: "Comment to All Students",
    Semester_Comment_Student: "Semester Comment",
    /// /////////////////////////////////////////////////////////
    /// /////////////////// Resources ///////////////////////////
    /// /////////////////////////////////////////////////////////
    Resources_Associated: "Associated Resources",
    /// /////////////////////////////////////////////////////////
    /// /////////////////// SLE /////////////////////////////////
    /// /////////////////////////////////////////////////////////
    Sle_Title: "School Level Expectations",
    Sle_Comment: "School Level Expectations Comment",
    Sle_Comment_To_All: "School Level Expectations Comment to All Students",
    Sle_No_Ratings: "No ratings entered",
    Sle_No_Comment: "No comment entered",
    /// /////////////////////////////////////////////////////////
    /// /////////////////// Subject /////////////////////////////
    /// /////////////////////////////////////////////////////////
    Subject_Selected: "Selected Subject",
    Subject_Comments: "Comments",
    Subject_Comment: "Comment",
    Subject_To_All: "Comment to All Students for", // [selected subject]
    Subject_Ratings: "Ratings",
    Subject_Accelerated: "Accelerated", // as in 'Advanced'
    Subject_Evidence_Outcome: "Evidence Outcome",
    Subject_Evidence_Outcome_Child: "Child Evidence Outcome(s)",
    Subject_Standard: "Standard", // as in "Educational Standard"
    Subject_Student_Comment: "Student Comment",
    /// /////////////////////////////////////////////////////////
    /// /////////////////// Archived ////////////////////////////
    /// /////////////////////////////////////////////////////////
    Archived_Description: "View or download your student's Archived Report Cards",
    Archived_Resources: "Archived Report Card Resources",
    Archived_Fail_1: "Sorry, we are unable to retrieve the Report Card PDF for the student for the school year", // sentence must end with [variable schoolYearName].
    Archived_Fail_2: (
        <>
            Please provide the following information when contacting the district for support:
            <br />
        </>
    ),
    Archived_Success: "Report Card PDF retrieved and downloaded successfully for the student for school year", // sentence must end with [variable schoolYearName]
    /// /////////////////////////////////////////////////////////
    /// /////////////////// 404 /////////////////////////////////
    /// /////////////////////////////////////////////////////////
    Page_Not_Found: "Page Not Found",
    Page_Not_Found_Message:
        "This application is not available based on the URL you entered OR your current position OR your current location."
};
